<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      height="80%"
      show-zoom
      resize
      transfer
      fullscreen
    >
      <template #title>
        <span>{{ rowId === 0 ? "新增专区" : "编辑专区" }}</span>
      </template>
      <template #default>
        <div class="btn-content">
          <el-button
            class="custom-button w-btn"
            size="small"
            type="primary"
            @click="handleSubmit"
            >保存
          </el-button>
          <el-button size="small" type="default" @click="handleCancel">
            关闭
          </el-button>
        </div>
        <el-form
          :model="formData"
          :rules="rules"
          size="small"
          label-position="right"
          status-icon
          ref="form"
          label-width="120px"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="专区名称" prop="name">
                <el-input v-model="formData.name" clearable required="true" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="优先级">
                <el-input-number
                  v-model="formData.priority"
                  :min="1"
                  class="w-number"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="类型" prop="type">
                <el-select v-model="formData.type">
                  <el-option
                    v-for="item in typeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图标" prop="icon">
                <img
                  v-if="!formData.icon"
                  style="width: 56px; height: 56px; cursor: pointer"
                  src="../../assets/images/upload.png"
                  alt=""
                  @click="imgClick"
                />
                <img
                  v-else
                  style="width: 56px; height: 56px; cursor: pointer"
                  :src="formData.iconUrl"
                  alt=""
                  @click="imgClick"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="省-市" prop="provinceId">
                <el-select
                  style="width: 49%"
                  v-model="formData.provinceId"
                  filterable
                  placeholder="请选择省"
                  @change="ProvinceChange"
                >
                  <el-option
                    v-for="item in ProvinceList"
                    :key="item.id"
                    :label="item.areaName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>

                <el-select
                  style="width: 50%"
                  v-model="formData.cityId"
                  filterable
                  placeholder="请选择市"
                >
                  <el-option
                    v-for="item in CityList"
                    :key="item.id"
                    :label="item.areaName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <template v-if="rowId != 0">
            <div v-scrollBottom style="height: 450px; overflow: auto">
              <el-row
                v-for="(item, index) in formData.homePageCategoryAddDTOs"
                :key="index"
                :gutter="20"
                style="display: flex; justify-content: center"
              >
                <div class="warp-content">
                  <div class="warp-head">
                    <el-form-item label="分类名称">
                      <div style="display: flex">
                        <el-input
                          v-model="item.category"
                          clearable
                          required="true"
                        />
                        <el-button
                          class="custom-button"
                          type="primary"
                          :icon="Search"
                          @click="onAddClass(index)"
                        >
                          <i
                            class="el-icon-circle-plus-outline custom-icon"
                          ></i>
                          <span>添加课程</span>
                        </el-button>
                      </div>
                    </el-form-item>
                    <el-form-item label="优先级">
                      <el-input-number
                        v-model="item.priority"
                        :min="1"
                        style="width: 300px"
                        class="w-number"
                      />
                    </el-form-item>
                    <div class="warp-head-btn">
                      <span @click="onOpen(index)">{{
                        isShowList[index] ? "收起" : "展开"
                      }}</span>
                      <span @click="removeCategory(index)">删除</span>
                    </div>
                  </div>
                  <div class="warp-table" v-show="isShowList[index]">
                    <ClassTable
                      :dataList="item.homePageListCourseAddDTOs"
                      @delete="onClassTableDelete($event, index)"
                    ></ClassTable>
                  </div>
                </div>
              </el-row>
            </div>
            <el-row
              :gutter="20"
              style="display: flex; justify-content: center; margin-top: 16px"
            >
              <div class="warp-add" @click="addCategory">
                <el-icon color="#0747A6"><Plus /></el-icon>添加分类
              </div>
            </el-row>
          </template>
        </el-form>
      </template>
    </vxe-modal>
    <!-- 资源中心 -->
    <SubResourceCenter
      ref="SubResourceCenter"
      v-model:ResourceCenterDialogVisible="ResourceCenterDialogVisible"
      @close-dialog="ResourceCenterCloseDialog"
      @handle-cancel="ResourceCenterHandleCancel"
      @handle-confirm="ResourceCenterHandleConfirm"
    ></SubResourceCenter>
    <ClassModel
      v-if="classDialogVisible"
      :classDialogVisible="classDialogVisible"
      @close-dialog="classDialogVisible = false"
      @handle-cancel="classDialogVisible = false"
      @handle-confirm="classHandleConfirm"
    ></ClassModel>
  </div>
</template>
<script>
import SubResourceCenter from "@views/YZResource/SubResourceCenter.vue";
import ClassModel from "./classModel.vue";
import ClassTable from "./classTable.vue";
import { Search } from "@element-plus/icons";
import { addHomePage, editHomePage, HomePageDetail } from "@api/Basic";
import { getUserInfo } from "@/util/authority";
import { ProvinceList } from "@/assets/apiData/Province";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: 0,
    },
  },
  components: { SubResourceCenter, Search, ClassModel, ClassTable },
  data() {
    return {
      ResourceCenterDialogVisible: false,
      classDialogVisible: false,
      typeList: [
        {
          value: 0,
          label: "课程类型",
        },
      ],
      formData: {
        name: "",
        status: true,
        priority: "",
        type: 0,
        icon: "",
        iconName: "",
        iconUrl: "",
        provinceId: "",
        cityId: "",
      },
      homePageCategory: [
        // {
        //   category: "",
        //   priority: 1,
        //   homePageListCourseAddDTOs: [],
        // },
      ],
      rules: {
        name: [{ required: true, message: "请输入专区名称", trigger: "blur" }],
        priority: [
          { required: true, message: "请输入优先级", trigger: "blur" },
        ],
        icon: [{ required: true, message: "请选择图标", trigger: "blur" }],
      },
      PageQuery: {
        queryModel: {
          title: "",
          courseCategoryIds: [],
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      categoryIndex: 0,
      isShowList: [],
      ProvinceList: [],
      CityList: [],
    };
  },
  watch: {
    "formData.homePageCategoryAddDTOs"(val) {
      this.isShowList = val.map((item) => true);
    },
  },
  created() {
    this.ProvinceList = JSON.parse(JSON.stringify(ProvinceList.entities));
    this.ProvinceList.unshift({
      areaName: "-请选择-",
      code: "",
    });
    if (this.rowId != 0) {
      this.getDetail();
    }
  },
  methods: {
    // 获取专区明细
    getDetail() {
      HomePageDetail(this.rowId).then((res) => {
        this.formData = res;
        // 省市回显处理
        this.ProvinceList.map((x) => {
          if (x.id == this.formData.provinceId) {
            this.CityList = JSON.parse(
              JSON.stringify(x.children.filter((o) => o.level == 3))
            );
            this.CityList.unshift({
              areaName: "-请选择-",
              id: "",
            });
          }
        });
      });
    },
    // 新增分类
    addCategory() {
      const categoryData =
        this.formData.homePageCategoryAddDTOs[
          this.formData.homePageCategoryAddDTOs.length - 1
        ];
      this.formData.homePageCategoryAddDTOs.push({
        category: "",
        priority: categoryData ? categoryData.priority + 1 : 1,
        homePageListCourseAddDTOs: [],
      });
    },
    // 删除分类
    removeCategory(index) {
      this.formData.homePageCategoryAddDTOs.splice(index, 1);
    },
    // 展开or收起
    onOpen(index) {
      this.isShow = !this.isShow;
      this.isShowList[index] = this.isShowList[index] ? false : true;
    },
    handleSubmit() {
      this.$refs.form.validate((valid, fields) => {
        if (valid) {
          let loading = this.$loading({
            lock: true,
            text: "正在提交，请稍后",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          const companyId = getUserInfo().CompanyId;
          this.formData.companyId = companyId;
          if (this.rowId === 0) {
            addHomePage(this.formData)
              .then((res) => {
                loading.close();
                if (res.id) {
                  this.$message.success("新增成功");
                  this.$emit("handle-confirm");
                }
              })
              .catch((err) => {
                loading.close();
                this.$message.error(err.message);
              });
          } else {
            editHomePage(this.formData)
              .then((res) => {
                loading.close();
                if (res) {
                  this.$message.success("编辑成功");
                  this.$emit("handle-confirm");
                }
              })
              .catch((err) => {
                loading.close();
                this.$message.error(err.message);
              });
          }
        } else {
          console.log("error submit!", fields);
        }
      });
    },
    handleClose() {
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.$emit("handle-cancel");
    },
    imgClick() {
      this.ResourceCenterDialogVisible = true;
      var obj = {
        type: ["4"], //展示的页签
        selectFileType: "4", //选中的文件的类型 1图片，2视频，3文档
        selectId: 0, //选中的文件的id
        isSingle: true, //是否单选
        row: {}, //行
        sourceItem: {}, //资源文件对象
      };
      this.$refs.SubResourceCenter.loading(obj);
    },
    ResourceCenterCloseDialog() {
      this.ResourceCenterDialogVisible = false;
    },
    ResourceCenterHandleCancel() {
      this.ResourceCenterDialogVisible = false;
    },
    ResourceCenterHandleConfirm(obj) {
      this.formData.icon = obj.sourceItem[0].PicLogicalCode;
      this.formData.iconName = obj.sourceItem[0].FileName;
      this.formData.iconUrl = obj.sourceItem[0].ImgSrcNew;
      this.ResourceCenterDialogVisible = false;
    },
    onAddClass(index) {
      this.categoryIndex = index;
      this.classDialogVisible = true;
    },
    // 过滤掉重复数据
    removeDuplicateObj(arr, key) {
      let obj = {};
      arr = arr.reduce((newArr, next) => {
        obj[next[key]] ? "" : (obj[next[key]] = true && newArr.push(next));
        return newArr;
      }, []);
      return arr;
    },
    classHandleConfirm(obj) {
      this.classDialogVisible = false;
      const newObj = obj.map((item) => {
        return {
          ...item,
          ...{
            homePageCategoryId:
              this.formData.homePageCategoryAddDTOs[this.categoryIndex].id,
            courceName: item.title,
            courceId: item.id,
            id: 0,
          },
        };
      });
      let list =
        this.formData.homePageCategoryAddDTOs[this.categoryIndex]
          .homePageListCourseAddDTOs;
      list = [...list, ...newObj];
      this.formData.homePageCategoryAddDTOs[
        this.categoryIndex
      ].homePageListCourseAddDTOs = this.removeDuplicateObj(list, "courceId");
    },
    onClassTableDelete(key, index) {
      this.formData.homePageCategoryAddDTOs[
        index
      ].homePageListCourseAddDTOs.splice(key, 1);
    },
    ProvinceChange() {
      this.formData.cityId = "";
      this.ProvinceList.map((x) => {
        if (x.id == this.formData.provinceId) {
          this.CityList = JSON.parse(
            JSON.stringify(x.children.filter((o) => o.level == 3))
          );
          this.CityList.unshift({
            areaName: "-请选择-",
            id: "",
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-button {
  background: #0747a6;
  border: 0;
  margin-left: 16px;
}
.btn-content {
  text-align: right;
  margin-bottom: 16px;
  .custom-button {
    background: #f7971e;
  }
}

.w-number {
  :deep(.el-input-number__decrease) {
    display: none;
  }
  :deep(.el-input-number__increase) {
    display: none;
  }
}

.warp-content {
  width: 90%;
  border-radius: 2px;
  border: 1px solid #b8c2c8;
  padding: 16px;
  margin-bottom: 16px;
  .warp-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    :deep(.el-form-item) {
      margin-bottom: 0;
    }
    .warp-head-btn {
      height: 32px;
      line-height: 32px;
      span {
        font-size: 16px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        cursor: pointer;
        &:first-of-type {
          color: #0747a6;
        }
        &:last-of-type {
          color: #fb3915;
          margin-left: 16px;
        }
      }
    }
  }
  .warp-table {
    margin-top: 16px;
    :deep(thead tr th) {
      background-color: #dfdfdf;
    }
  }
}
.warp-add {
  width: 93%;
  height: 44px;
  border-radius: 2px;
  border: 1px dashed #b8c2c8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #0747a6;
  cursor: pointer;
  :deep(.el-icon) {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #0747a6;
  }
}
</style>